export default {
  AlarmEvent: '告警事件',
  EventName: '事件名称',
  AlarmTime: '告警时间',
  EventType: '事件类型',
  Importance: '级别',
  Branch: '分支机构',
  RelationGateway: '关联网关',
  RelationCpe: '关联设备',
  SearchPlaceholder: '搜索设备号/设备别名/网关号/分支机构/事件内容',
  AlarmConfig: '告警配置',
  MessageSubscribe: '消息订阅',
  Low: '低',
  High: '高',
  AlarmSwitch: '告警开关',
  MonitoringGateway: '监测网关',
  AlarmValue: '告警值',
  AlarmCondition: '告警条件',
  AddReceiver: '新建接收人',
  EditReceiver: '编辑接收人',
  SubscribeTips: '告警开关默认关闭，您可以根据需要自行配置。重要程度高的事件建议保持开启告警状态，以便于及时了解服务健康情况。',
  SubscribeSwitch: '订阅开关',
  Receiver: '接收人',
  ReceiveMode: '接收方式',
  ReceivePhone: '接收手机',
  ReceiveEmail: '接收邮箱',
  InputPositiveInteger: '填写正整数',
  Frequency: '次',
  AllGateways: '全部网关',
  PartialGateway: '部分网关',
  SearchGatewayName: '搜索请输入网关名',
  AlarmValuePlaceholder: '填写1-100',
  Number: '个',
  CpeStatusChangeToOnline: '设备状态变更为上线',
  CpeStatusChangeToOffline: '设备状态变更为下线',
  UnableConnect: '设备全链路无法连通',
  CurrentFlowLinkSwitched: '当前流量转发链路发生切换',
  AlarmConditionsTip: '触发告警的条件：连续超过告警值的次数达到所设置的次数将会触发告警',
  AlarmConditionsPlaceholder: '请选择告警条件',
  AlarmEventTip: '低：当前告警事件不影响业务、性能\n中：当前告警事件可能对业务、性能造成影响\n高：当前告警事件将对业务、性能等造成影响',
  ReceiverName: '接收人名称',
  PhonePlaceholder: '填写需接收告警通知的手机号',
  EmailPlaceholder: '填写需接收告警通知的邮箱',
  ReceiverModeRequire: '请勾选接收方式并填写接收人的联系信息',
  ReceiverDetailInfoRequire: '请填写接收方式详细信息',
  InfoDeleteConfirm: '确定删除当前接收人？',
  InfoDeleteTip: '删除后不可恢复，如有需要可再次添加',
  Duration: '持续时长',
  AlarmStatu: '告警状态',
  AddReceiverSuccess: '新建接收人成功',
  AlarmValueRequire: '请填写告警值',
  isNotRequired: (title: string) => `格式有误，请输入真实有效的${title}`,
  EventContent: '事件内容',
}
  